export default __webpack_public_path__ + "static/media/spinner.1c079777.gif";